import PropTypes from 'prop-types';
import React from 'react';
import Link from '../Link';
import Cell from './Cell';
const EmailCell = /*#__PURE__*/React.memo(_ref => {
  let {
    email,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Cell, props, email ? /*#__PURE__*/React.createElement(Link, {
    href: "mailto:".concat(email)
  }, email) : null);
});
EmailCell.propTypes = {
  email: PropTypes.string
};
EmailCell.defaultProps = {};
EmailCell.displayName = 'EmailCell';
export default EmailCell;